import React from 'react';
import {connect} from 'react-redux';
import {EARRING} from "../../constants";
import Letter from '../lib/Letter';

class OneEarringPreview extends React.Component {
    render() {
        let [line1, line2, line3, line4] = this.props.input;

        return (
            <>
                {line1.length !== 0 ? (
                    <>
                        <div className='customizer-preview__line'>
                            {line1.split('').map((letter, index) => <Letter key={index} letter={letter}/>)}
                        </div>
                        <div className='customizer-preview__line'>
                            {line2.split('').map((letter, index) => <Letter key={index} letter={letter}/>)}
                        </div>
                    </>
                ):(
                    <div>type something</div>
                )}
            </>
        );
    }
}

class TwoEarringsPreview extends React.Component {
    render() {
        let [line1, line2, line3, line4] = this.props.input;

        return (
            <>
                {(line1.length !== 0 && line3.length !==0) ? (
                    <>
                        <div className="customizer-preview__half">
                            <div className='customizer-preview__line'>
                                {line1.split('').map((letter, index) => <Letter key={index} letter={letter}/>)}
                            </div>
                            <div className='customizer-preview__line'>
                                {line2.split('').map((letter, index) => <Letter key={index} letter={letter}/>)}
                            </div>
                        </div>
                        <div className="customizer-preview__half">
                            <div className='customizer-preview__line'>
                                {line3.split('').map((letter, index) => <Letter key={index} letter={letter}/>)}
                            </div>
                            <div className='customizer-preview__line'>
                                {line4.split('').map((letter, index) => <Letter key={index} letter={letter}/>)}
                            </div>
                        </div>
                    </>
                ):(
                    <div>type something</div>
                )}
            </>
        );
    }
}

class PreviewContainer extends React.Component {
    render() {
        let className = '';
        className += `customizer-preview `;
        className += `customizer-preview--earring `;
        className += `customizer-preview--${this.props.earringQuantity.description.toLowerCase().replace(' ', '-')} `;
        className += `${this.props.color.description.toLowerCase().replace(' ', '-')} `;

        return (
            <div className={className}>
                <div className="customizer-preview__container">
                    {this.props.earringQuantity === EARRING.ONE &&
                        <OneEarringPreview input={this.props.input} color={this.props.color}/>
                    }
                    {this.props.earringQuantity === EARRING.PAIR &&
                        <TwoEarringsPreview input={this.props.input} color={this.props.color}/>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        input: state.earringInput,
        earringQuantity: state.earringQuantity,
        color: state.goldColor,
    }
};

export default connect(mapStateToProps)(PreviewContainer);
